document.addEventListener('DOMContentLoaded', function () {
  // Hamburger toggle
  var hamburgerBtn = document.getElementById('hamburger-btn');
  var hamburgerNav = document.getElementById('hamburger-nav');
  var closeBtn = document.getElementById('close-btn');

  if (hamburgerBtn && hamburgerNav) {
    hamburgerBtn.addEventListener('click', function () {
      hamburgerNav.classList.add('open');
    });
  }

  if (closeBtn && hamburgerNav) {
    closeBtn.addEventListener('click', function () {
      hamburgerNav.classList.remove('open');
    });
  }

  // Menu event (hover / click)
  var menuEvent = document.body.querySelector('.main-header')?.getAttribute('class').includes('menu-event-click') ? 'click' : 'hover';
  var header = document.querySelector('.main-header');
  if (!header) return;

  // Reset
  header.classList.remove('menu-event-hover', 'menu-event-click');
  document.querySelectorAll('.nav-item.submenu-open').forEach(item => item.classList.remove('submenu-open'));
  document.querySelectorAll('.nav-item.has-submenu > a').forEach(link => (link.onclick = null));

  if (menuEvent === 'hover') {
    header.classList.add('menu-event-hover');
  } else if (menuEvent === 'click') {
    header.classList.add('menu-event-click');
    header.querySelectorAll('.nav-item.has-submenu > a').forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const parent = link.parentElement;
        const isOpen = parent.classList.contains('submenu-open');
        header.querySelectorAll('.nav-item.submenu-open').forEach(item => item.classList.remove('submenu-open'));
        if (!isOpen) parent.classList.add('submenu-open');
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav-item')) {
        header.querySelectorAll('.nav-item.submenu-open').forEach(item => item.classList.remove('submenu-open'));
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const cartCountEl = document.querySelector(".header-cart-count");

  // Function to fetch and update cart count
  function updateCartCount() {
    fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
        cartCountEl.textContent = cart.item_count;
      })
      .catch(error => console.error("Cart update error:", error));
  }

  // Listen for Shopify's built-in event when items are added
  document.body.addEventListener("ajaxProduct:added", updateCartCount);

  // If your add-to-cart uses a form, hook into it:
  document.querySelectorAll("form[action*='/cart/add']").forEach(form => {
    form.addEventListener("submit", function(e) {
      // Wait a bit after product is added, then update
      setTimeout(updateCartCount, 500);
    });
  });
});


